import { ResultOf } from "gql.tada";
import { InspoCarouselSectionById } from "../../../queries/entries/InspoCarouselSectionById";
import { motion, useScroll, useTransform, easeInOut } from "motion/react";
import { useRef } from "react";
import { TitleSection } from "../TitleSection";
import { InspoCarousel } from "./InspoCarousel";

export const InspoCarouselSection = ({
  entry: { inspoCarouselSection: entry },
}: {
  entry: ResultOf<typeof InspoCarouselSectionById>;
}) => {
  const sectionRef = useRef(null);
  const { scrollYProgress: frameEntryScrollProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "center center"],
  });
  const borderRadius = useTransform(frameEntryScrollProgress, [0, 1], [64, 0]);

  const { scrollYProgress: frameContentFullFillPeriod } = useScroll({
    target: sectionRef,
  });

  const segmentCount = 5;
  const transformedScale = useTransform(
    frameContentFullFillPeriod,
    [
      ...Array.from(
        { length: segmentCount },
        (_, index) => index / segmentCount
      ).flat(),
    ],
    [
      ...Array.from({ length: segmentCount }, (_, index) => {
        return easeInOut(index / (segmentCount - 1));
      }).flat(),
    ]
  );

  if (!entry) return null;

  return (
    <section ref={sectionRef} className="h-[500vh]">
      <div className="h-screen w-full sticky top-0">
        <TitleSection entry={entry} />
        <motion.div
          style={{
            scale: transformedScale,
            transformOrigin: "bottom",
            borderRadius,
          }}
          className="h-screen w-full absolute bottom-0 overflow-hidden bg-palette-current-background"
        >
          <InspoCarousel
            entry={entry}
            fullFillPeriodMv={frameContentFullFillPeriod}
          />
        </motion.div>
      </div>
    </section>
  );
};
